/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import {
  Typography,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const messages = defineMessages({
  unitsPercent: {
    id: 'Elearning.units',
    defaultMessage: '% Programme',
  },
});

const renderTextField = ({
  input,
  label,
  ...custom
}) => (
  <TextField
    label={label}
    {...input}
    {...custom}

  />
);

const ElearningUnitsPercent = (props) => {
  const { intl } = props;
  const queryParams = new URLSearchParams(window.location.search);
  const update = queryParams.get('update');
  return (
    <>
      <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
        {intl.formatMessage(messages.unitsPercent)}
      </Typography>
      <Field
        name={update === 'true' ? 'elearning.elearningAttempts' : 'elearningAttempts'}
        label={intl.formatMessage(messages.unitsPercent)}
        style={{ width: '100%' }}
        id="filled-number"
        variant="outlined"
        type="number"
        inputProps={{ min: '0', max: '100', step: '5' }}
        component={renderTextField}
      />
    </>
  );
};

ElearningUnitsPercent.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return ({ initialValues: state.group.selectedGroup, form: name, dataform });
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,

})(injectIntl(ElearningUnitsPercent));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default (NewconnectedGroupForm);
